/**
 * AddressesProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'

import AddressesContext from './addresses-context'
import {
  fetchCountries,
  fetchStatesCitiesDistricts,
  fetchStreet,
  fetchZip,
} from './addresses-api'

export default function AddressesProvider({ children }) {
  return (
    <AddressesContext.Provider
      value={{
        fetchCountries,
        fetchStatesCitiesDistricts,
        fetchStreet,
        fetchZip
      }}
    >
      {children}
    </AddressesContext.Provider>
  )
}
